import React, { useState, useEffect } from 'react';
import { SearchIcon } from '../icons/SearchIcon';

const SearchBar = ({ onSearch, variant = 'default' }) => {
  const [searchQuery, setSearchQuery] = useState('');
  const [placeholder, setPlaceholder] = useState('Search');
  const [isActive, setIsActive] = useState(false);

  // Debounce effect: wait 500ms after the last input change and only update if active.
  useEffect(() => {
    const timer = setTimeout(() => {
      if (onSearch && isActive) {
        onSearch(searchQuery);
      }
    }, 500);
    return () => clearTimeout(timer);
  }, [searchQuery, onSearch, isActive]);

  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && onSearch && isActive) {
      onSearch(searchQuery);
    }
  };

  const handleChange = (e) => {
    setSearchQuery(e.target.value);
  };

  const handleFocus = () => {
    setIsActive(true);
    setPlaceholder('');
  };

  const handleBlur = () => {
    setIsActive(false);
    setPlaceholder('Search');
  };

  // Style variants
  const getInputStyles = () => {
    const baseStyles = "pl-10 pr-4 py-2 font-gazer-light focus:outline-none placeholder:text-[#8F9BBA]";
    
    switch (variant) {
      case 'compact':
        return `${baseStyles} rounded w-48 h-8`;
      case 'default':
      default:
        return `${baseStyles} rounded-l-[100px] w-44 bg-[#F4F7FE] h-[40px]`;
    }
  };

  return (
    <div className="relative flex items-center">
      
      <SearchIcon className="absolute left-3 w-5 h-5 text-[#2B3674]" />
      {/* Input Field */}
      <input
        type="text"
        value={searchQuery}
        onChange={handleChange}
        onKeyPress={handleKeyPress}
        onFocus={handleFocus}
        onBlur={handleBlur}
        placeholder={placeholder}
        className={getInputStyles()}
      />
    </div>
  );
};

export default SearchBar;